import { Box, Button, Checkbox, Chip, Divider, FormControl, FormControlLabel, Grid, IconButton, Paper, Radio, RadioGroup, Step, StepLabel, Stepper, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../Redux/store';
import { CartItem } from '../Models/Cartlist';
import { Product } from '../Models/Products';
import { Add, Delete, DeleteForever, DeleteOutlineOutlined, EditOutlined, LocalShippingOutlined, Remove } from '@mui/icons-material';
import { number } from 'yup';
import { toast } from 'react-toastify';
import { ApiAddAddress, ApiCreateOrder, ApiDeleteAddress, ApiDeleteCartitem, ApiGetAddress, ApiUpdateCartlist } from '../Core/Apicall';
import { ShippingAddress } from '../Models/Address';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { setActiveStep } from '../Redux/Reducers/globalSlice';
import { useNavigate } from 'react-router-dom';




const steps = [
    "BAG",
    "ADDRESS",
    "PAYMENT",
];


interface CartItemsProps {
    cartItems: CartItem[];
    setCartItems: (value: any) => void;
}
interface AddressItemsProps {
    selectedAddress: number | null;
    setSelectedAddress: (value: number) => void;
}




export function CartItems({
    cartItems,
    setCartItems,
}: CartItemsProps) {
    // const [cartItems, setCartItems] = useState<CartItem[]>([]);

    const updateCartQuantity = async (
        cartItemId: number,
        newQuantity: number
    ) => {
        try {
            setCartItems((prev: CartItem[]) =>
                prev.map((item: CartItem) =>
                    item.cartItemId === cartItemId
                        ? { ...item, quantity: newQuantity }
                        : item
                )
            );
            const data1 = `?cartItemId=${cartItemId}`
            const data2 = {
                "seller_type": "TEAM",
                quantity: newQuantity,
            }
            await ApiUpdateCartlist(data1, data2);

        } catch (error: any) {
            toast.error(error?.message)
        }
    };

    const handleIncrease = (item: CartItem) => {
        if (item.quantity < Number(item.variant?.stock)) {
            updateCartQuantity(
                item.cartItemId,
                item.quantity + 1
            );
        }
    };

    const handleDecrease = (item: CartItem) => {
        if (item.quantity > 1) {
            updateCartQuantity(
                item.cartItemId,
                item.quantity - 1
            );
        }
    };

    const handleRemoveItem = async (cartItemId: number) => {
        const isConfirm = window.confirm("Are you sure you want to remove this item?")
        if (!isConfirm) return;
        try {
            const data = `?cartItemId=${cartItemId}`
            setCartItems((prev: CartItem[]) =>
                prev.filter((item) => item.cartItemId !== cartItemId)
            );
            await ApiDeleteCartitem(data)
        } catch (error: any) {
            toast.error(error?.message)
        }
    }

    return (
        <Grid className='filters pe-3 border-right-light-main' size={{ xs: 12, md: 9 }}>
            <Grid container spacing={2}>
                {cartItems?.map((item: CartItem) => {
                    return (
                        <Grid size={12} className='border-main p-2 border-10' key={item.cartItemId}>
                            <Box className='d-flex align-items-start gap-3'>
                                <Box>
                                    <Box
                                        component="img"
                                        className="border-10 bg-light"
                                        src={item?.product?.media?.[0]?.media_url}
                                        alt={item?.product?.productName}
                                        sx={{
                                            width: {
                                                xs: "100px",
                                                md: "150px",
                                                lg: "200px",
                                            },
                                            objectFit: "cover",
                                        }}
                                    />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography className="text-white fw-bold fs-24 mt-2">
                                        {item?.product?.productName}
                                    </Typography>
                                    <Typography className="fs-18 text-grey">
                                        {item?.variant?.name}
                                    </Typography>

                                    <Typography className="text-white fw-bold fs-24 align-items-baseline">
                                        ${item?.product?.discounted_price}

                                        {Number(item?.product?.discount_percentage) > 0 && (
                                            <>
                                                <span className="over-line fs-18 ms-2">
                                                    ${item?.product?.base_price}
                                                </span>

                                                <span className="text-green ms-2">
                                                    {Number(item?.product?.discount_percentage).toFixed(0)}% off
                                                </span>
                                            </>
                                        )}
                                    </Typography>

                                    <Box className='mt-3'>
                                        <Box sx={{ width: 'fit-content' }} className='d-flex align-items-center border border-10 border-main overflow-hidden'
                                        >
                                            <IconButton
                                                onClick={() => { handleDecrease(item) }}
                                                disabled={item?.quantity === 1}
                                                sx={{ borderRadius: 0 }}
                                            >
                                                <Remove sx={{ color: 'white' }} />
                                            </IconButton>

                                            <Typography className='text-white text-center fw-bold mx-2'
                                            >
                                                {item?.quantity}
                                            </Typography>

                                            <IconButton
                                                disabled={item?.quantity === Number(item?.variant?.stock)}
                                                onClick={() => { handleIncrease(item) }}
                                                sx={{ borderRadius: 0 }}
                                            >
                                                <Add sx={{ color: 'white' }} />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Box>
                                {/* <IconButton onClick={() => { handleRemoveItem(item?.cartItemId) }}><Delete className='text-danger' /></IconButton> */}
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>
        </Grid>
    )
}

export function Address({
    selectedAddress,
    setSelectedAddress
}: AddressItemsProps) {
    const [addresslist, setAddresslist] = useState<ShippingAddress[]>()

    const getAddress = async () => {
        try {
            const res = await ApiGetAddress()
            if (res?.success) {
                setAddresslist(res?.data)
                setSelectedAddress(
                    res?.data?.find((item: ShippingAddress) => item.is_default)
                        ?.shippingAddressId
                );
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    useEffect(() => {
        getAddress()
    }, [])

    const validationSchema = Yup.object({
        full_name: Yup.string().required("Full Name is required"),
        mobile_number: Yup.string()
            .required("Phone Number is required")
            .matches(/^[0-9]{10}$/, "Enter a valid 10-digit phone number"),
        // email: Yup.string()
        //     .email("Enter a valid email")
        //     .required("Email is required"),
        address_line_1: Yup.string().required("Address Line 1 is required"),
        address_line_2: Yup.string().required("Address Line 2 is required"),
        city: Yup.string().required("City is required"),
        postal_code: Yup.string().required("Pincode is required"),
        state: Yup.string().required("State is required"),
        country: Yup.string().required("Country is required"),
    });

    const formik = useFormik({
        initialValues: {
            full_name: "",
            mobile_number: "",
            // email: "",
            address_line_1: "",
            address_line_2: "",
            city: "",
            postal_code: "",
            state: "",
            country: "",
            is_default: false,
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                const res = await ApiAddAddress(values)
                if (res?.success) {
                    getAddress()
                    formik.resetForm()
                }
            } catch (error: any) {
                toast.error(error?.message || "Something went wrong ")
            }
        },
    });

    const handleDeleteAddress = async (address: any) => {
        try {
            const data = ``
            const res = await ApiDeleteAddress(data)
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    return (
        <Grid className='filters bg-grey p-3 px-4 border-main h-content border-10 border-right-light-main' size={{ xs: 12, md: 9 }}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <Typography className='fs-20 fw-bold text-white'>
                        Delivery Address
                    </Typography>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Typography className='fs-16 text-grey mb-2'>
                        Saved Addresses
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12 }} className='mb-3'>
                    <RadioGroup
                        value={selectedAddress}
                        onChange={(e) => setSelectedAddress(Number(e.target.value))}
                        className='w-100'
                    >
                        <Grid container spacing={1} className='extra'>
                            {addresslist?.map((address: ShippingAddress) => (
                                <Grid size={{ xs: 12, md: 'grow' }}>
                                    <Paper
                                        key={address.shippingAddressId}
                                        className="p-2 px-3 d-flex align-items-start gap-2 border-10 bg-transparent"
                                        sx={{
                                            border:
                                                selectedAddress === address.shippingAddressId
                                                    ? "2px solid var(--third-color)"
                                                    : "1px solid var(--text-grey)",
                                        }}
                                    >
                                        <FormControlLabel
                                            value={address.shippingAddressId}
                                            control={<Radio checked={selectedAddress === address.shippingAddressId} sx={{ color: "var(--text-grey)" }} />}
                                            label={
                                                <Box>
                                                    <Typography className="fw-bold text-white fs-14">
                                                        {/* {address.} */}
                                                    </Typography>

                                                    <Typography className='text-white fs-14'>
                                                        {address.full_name}
                                                    </Typography>

                                                    <Typography className="text-white fs-12">
                                                        {address.address_line_1},
                                                        {address.address_line_2},
                                                        {address.city},
                                                        {address.state},
                                                        {address.country}-
                                                        {address.postal_code}
                                                    </Typography>

                                                    <Typography className="text-white fs-12">
                                                        {address.mobile_number}
                                                    </Typography>
                                                </Box>
                                            }
                                        />
                                        <Box className='d-flex align-items-center gap-1'>
                                            {/* <IconButton className='m-0 p-0'><EditOutlined className='text-yellow' /></IconButton> */}
                                            <IconButton className='m-0 p-0' onClick={() => { handleDeleteAddress(address) }}><DeleteOutlineOutlined className='text-danger' /></IconButton>
                                        </Box>
                                    </Paper>

                                </Grid>
                            ))}
                        </Grid>
                    </RadioGroup>
                </Grid>

                {/* Divider */}
                <Grid size={{ xs: 12 }}>
                    <Divider className='text-grey' sx={{
                        "&::before, &::after": {
                            borderColor: "var(--text-grey)",
                        },
                    }}>OR</Divider>
                </Grid>

                Add Address
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 6 }} className="form">
                            <TextField
                                fullWidth
                                required
                                label="Full Name"
                                name="full_name"
                                value={formik.values.full_name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.full_name && Boolean(formik.errors.full_name)}
                                helperText={formik.touched.full_name && formik.errors.full_name}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }} className="form">
                            <TextField
                                fullWidth
                                required
                                label="Phone Number"
                                name="mobile_number"
                                value={formik.values.mobile_number}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.mobile_number && Boolean(formik.errors.mobile_number)}
                                helperText={formik.touched.mobile_number && formik.errors.mobile_number}
                            />
                        </Grid>

                        {/* <Grid size={{ xs: 12 }} className="form">
                                    <TextField
                                        fullWidth
                                        required
                                        label="Email Address"
                                        name="email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.email && Boolean(formik.errors.email)}
                                        helperText={formik.touched.email && formik.errors.email}
                                    />
                                </Grid> */}

                        <Grid size={{ xs: 12 }} className="form">
                            <TextField
                                fullWidth
                                required
                                label="Address Line 1"
                                name="address_line_1"
                                value={formik.values.address_line_1}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.address_line_1 &&
                                    Boolean(formik.errors.address_line_1)
                                }
                                helperText={
                                    formik.touched.address_line_1 &&
                                    formik.errors.address_line_1
                                }
                            />
                        </Grid>

                        <Grid size={{ xs: 12 }} className="form">
                            <TextField
                                fullWidth
                                required
                                label="Address Line 2"
                                name="address_line_2"
                                value={formik.values.address_line_2}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.address_line_2 &&
                                    Boolean(formik.errors.address_line_2)
                                }
                                helperText={
                                    formik.touched.address_line_2 &&
                                    formik.errors.address_line_2
                                }
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }} className="form">
                            <TextField
                                fullWidth
                                required
                                label="City"
                                name="city"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.city && Boolean(formik.errors.city)}
                                helperText={formik.touched.city && formik.errors.city}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }} className="form">
                            <TextField
                                fullWidth
                                required
                                label="Pincode"
                                name="postal_code"
                                value={formik.values.postal_code}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.postal_code &&
                                    Boolean(formik.errors.postal_code)
                                }
                                helperText={
                                    formik.touched.postal_code &&
                                    formik.errors.postal_code
                                }
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }} className="form">
                            <TextField
                                fullWidth
                                required
                                label="State"
                                name="state"
                                value={formik.values.state}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.state && Boolean(formik.errors.state)}
                                helperText={formik.touched.state && formik.errors.state}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }} className="form">
                            <TextField
                                fullWidth
                                required
                                label="Country"
                                name="country"
                                value={formik.values.country}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.country && Boolean(formik.errors.country)}
                                helperText={formik.touched.country && formik.errors.country}
                            />
                        </Grid>

                        <Grid size={{ xs: 12 }} className="form">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="is_default"
                                        checked={formik.values.is_default}
                                        onChange={formik.handleChange}
                                        sx={{ color: "var(--text-grey)" }}
                                    />
                                }
                                label="Save this address as default address"
                            />
                        </Grid>

                        <Grid
                            size={{ xs: 12 }}
                            className="form d-flex justify-content-end"
                        >
                            <Button
                                type="submit"
                                className="btn-yellow"
                                variant="contained"
                            >
                                + Add Address
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Grid>
        </Grid>
    )
}


function Cart() {
    const activeStep = useSelector(
        (state: RootState) => state.global.activeStep
    )
    const dispatch = useDispatch();
    const { cartlist } = useSelector((state: RootState) => state.global)
    const [cartItems, setCartItems] = useState<CartItem[]>([]);
    const [selectedAddress, setSelectedAddress] = useState<number | null>(null);
    const navigate = useNavigate()

    useEffect(() => {
        setCartItems(cartlist?.items || []);
    }, [cartlist]);

    const handleNext = () => {
        if (activeStep < steps.length) {
            // setActiveStep((prev) => prev + 1);
            dispatch(setActiveStep(activeStep + 1));
        }
    };
    const handleBack = () => {
        if (activeStep > 0) {
            dispatch(setActiveStep(activeStep - 1));
        }
    };

    const handleReset = () => {
        // setActiveStep(0);
        dispatch(setActiveStep(0));
    };


    const subtotal = cartItems.reduce(
        (sum, item) =>
            sum +
            Number(item.product?.discounted_price || 0) * Number(item.quantity),
        0
    );

    const totalMRP = cartItems.reduce(
        (sum, item) =>
            sum +
            Number(item.product?.base_price || 0) * Number(item.quantity),
        0
    );

    const discount = totalMRP - subtotal;

    const tax = subtotal * 0.05;

    const total = subtotal + tax;

    const totalItems = cartItems.reduce(
        (sum, item) => sum + Number(item.quantity),
        0
    );


    const CreateOrder = async () => {
        if(!selectedAddress || !cartlist || !tax){toast.error("Something went wrong"); return;}
        try {
            const data = {
                cartId: cartlist?.cartId,
                shippingAddressId: selectedAddress,
                // "couponId": 1,
                shipping_amount: 0,
                tax_amount: tax,
                payment_method: "COD",
                notes:"Please deliver in the evening"
            }
            const res = await ApiCreateOrder(data)
            if(res?.success){
                navigate('/')
            }
        } catch (error:any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    const getStepContent = (step: any) => {
        switch (step) {
            case 0:
                return (
                    cartlist && <CartItems cartItems={cartItems} setCartItems={setCartItems} />
                );
            case 1:
                return (
                    cartlist && <Address selectedAddress={selectedAddress} setSelectedAddress={setSelectedAddress} />
                );
            case 2:
                return (
                    <></>
                    // <Typography className='text-white'>
                    //     Review all information and click Submit.
                    // </Typography>
                );
            default:
                return null;
        }
    };

    return (
        <Box className='h-content stepper  w-100 p-3 p-md-5' sx={{ height: 'calc(100vh - 80px)' }}>
            <Paper className='h-100 mx-auto text-white border-0' sx={{ background: 'transparent', maxWidth: '1400px', boxShadow: 'none' }} >
                <Stepper
                    className='gap-5 mx-auto p-0 fs-20 position-relative'
                    activeStep={activeStep}
                    alternativeLabel
                    sx={{
                        width: "fit-content",
                    }}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                {activeStep === steps.length ? (
                    <Box className='text-center'>
                        <Typography variant="h5" gutterBottom>
                            Form Submitted Successfully!
                        </Typography>

                        <Button
                            variant="contained"
                            onClick={handleReset}
                            sx={{ mt: 2 }}
                        >
                            Reset
                        </Button>
                    </Box>
                ) : (
                    <Box className='h-content d-flex flex-column'>
                        <Box className='w-100' sx={{ flex: 1, minHeight: 120, margin: "30px auto" }}>
                            <Grid container spacing={2} sx={{ alignItems: 'stretch' }} className='h-100'>
                                {getStepContent(activeStep)}
                                <Grid size={{ xs: 12, md: 3 }} className='bg-grey p-3 border-main border-10'>
                                    <Box>
                                        <Typography className="fw-bold fs-20 mb-3">
                                            Order Summary
                                        </Typography>

                                        <Box className="d-flex justify-content-between mb-3">
                                            <Typography className="text-grey fs-14">
                                                Subtotal ({totalItems} item{totalItems > 1 ? "s" : ""})
                                            </Typography>

                                            <Typography className="text-white fs-16">
                                                ${subtotal.toFixed(2)}
                                            </Typography>
                                        </Box>

                                        <Box className="d-flex justify-content-between mb-3">
                                            <Typography className="text-grey fs-14">
                                                Tax (5%)
                                            </Typography>

                                            <Typography className="text-white fs-16">
                                                ${tax.toFixed(2)}
                                            </Typography>
                                        </Box>

                                        <Box className="d-flex justify-content-between mb-3">
                                            <Typography className="text-grey fs-14">
                                                Discount
                                            </Typography>

                                            <Typography
                                                className="fs-16 fw-bold"
                                                sx={{ color: "#22c55e" }}
                                            >
                                                ${discount.toFixed(2)}
                                            </Typography>
                                        </Box>

                                        <Box className="d-flex justify-content-between mb-3">
                                            <Typography className="text-grey fs-14">
                                                Delivery
                                            </Typography>

                                            <Typography
                                                className="fs-18 fw-bold"
                                                sx={{ color: "#22c55e" }}
                                            >
                                                Free
                                            </Typography>
                                        </Box>

                                        <Divider sx={{ my: 2, borderColor: "#ffffff33" }} />

                                        <Box className="d-flex justify-content-between align-items-center">
                                            <Typography className="fw-bold fs-20">
                                                Total
                                            </Typography>

                                            <Typography className="fw-bold fs-24 text-white">
                                                ${total.toFixed(2)}
                                            </Typography>
                                        </Box>

                                        <Typography
                                            // sx={{ color: "var()" }}
                                            className="fw-bold text-yellow fs-16 mt-3"
                                        >
                                            You save ${discount.toFixed(2)} on this order
                                        </Typography>

                                        <Box className='d-flex border-10 border-main p-2 w-content align-items-stretch gap-2 mt-3'>
                                            <Box className='border-50 bg-green p-2'>
                                                <LocalShippingOutlined className='text-green' />
                                            </Box>
                                            <Box>
                                                <Typography className="fw-bold fs-14">
                                                    Estimated Delivery
                                                </Typography>
                                                <Typography className="fw-bold fs-14">
                                                    28 May - 31 May, 2024
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                               { activeStep === steps.length - 1 && (<Grid size={{ xs: 12 }}>
                                    <Box className='d-flex align-items-center justify-content-center'>
                                        <Button onClick={() => { CreateOrder() }} className='btn-yellow px-4'>Order Now</Button>
                                    </Box>
                                </Grid>
                                )}
                            </Grid>

                        </Box>


                        <Box className='d-flex justify-content-between mb-3'>
                            <Button
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                variant="outlined"
                                className='border-white text-white'
                            >
                                Back
                            </Button>

                            {(activeStep < steps.length - 1) && (
                                <Button
                                    className='btn-main'
                                    variant="contained"
                                    onClick={handleNext}
                                >
                                    {activeStep === steps.length - 1 ? "Submit" : "Next"}
                                </Button>
                            )}
                        </Box>
                    </Box>
                )}
            </Paper>
        </Box>
    )
}

export default Cart
